module.exports = __webpack_public_path__ + "static/media/pic2@2x.65dddcb0.png";